module.exports = __webpack_public_path__ + "img/bg-r@2x.a5549050.jpg";